const VARS = {
  API_URL: "https://devsud.fonetricks.com",
  SOCKET_URL: "https://devsud.fonetricks.com"
}

export default VARS